// extracted by mini-css-extract-plugin
export default {"comment_info_label":"styles_comment_info_label__JySyt","commented_persons_type_tag":"styles_commented_persons_type_tag__nZ2gs","commented_date":"styles_commented_date__nwZ1y"};